import { h, Component, Fragment } from "preact";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Observer from "../../utils/observer";
import User from "../../../../services/user";
import {BETS_SEARCH_STATUSES, BETS_STATUS, OUTCOMES_STATUS} from "../../utils/ticket-statuses";
import {Cell, CustomTable, EmptyRecordsMessage, FiltersRow, HCell, HRow, Pagination, Panel, PanelRow, Row} from "../../utils/table-utils";
import {DateHelperFilter, PerPageFilter} from "../../utils/form-utils";
import TicketLogic from "../../utils/ticket-logic";
import CashoutService from "../../../../services/cashout";
import MoneyFormatter from "../../utils/money-formatter";
import OddsFormatter from "../../utils/odds-formatter";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";

import { useHeadlessComponent } from "../../../../utils/component-converter";
import AwrabetBetsHistoryPage, {
    BetsTable as ArwabetBetsTable,
    BetsTableRow as ArwabetBetsTableRow,
} from "../../../awrabet/desktop-components/user/menu-bets-history";

export default function BetsHistoryPage(props) {
    const api = useHeadlessComponent(AwrabetBetsHistoryPage, props);
    const { state } = api;

    return <div>
        <div class="overflow-x-auto user-menu-subnav">
            <U.SubTabsContainer>
                {Object.entries(state.statustypes).map(
                    ([key,item]) => <U.Tab selected={key === state.statusfilter} onClick={e => api.changeFilter(key)} >{item.label}</U.Tab>
                )}
            </U.SubTabsContainer>
        </div>
        <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{state.statustypes[state.statusfilter].description}</div>
        <FiltersRow class="gap-2 flex flex-col sm:flex-row p-2 text-sm sm:items-end justify-center items-stretch">
            <DateHelperFilter
                {...state.dateFilter}
                onInput={
                    (dateFilter) => {
                        api.state.dateFilter = dateFilter;
                        api.setState(api.state);
                    }
                }
            />
            <PerPageFilter
                perPage={state.perPage}
                pageList={[15,30,45,50,100]}
                onInput={
                    ({perPage}) => {
                        api.state.perPage = perPage;
                        api.setState(api.state);
                    }
                }
            />
            <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => api.performSearch()}>
                <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
            </a>
        </FiltersRow>
        <div class="text-sm mt-3">
            <BetsTable
                {...state.response}
                onIdClick={ticket => TicketLogic.printTicket(ticket)}
                onNavigation={api.changePage}
            />
        </div>
    </div>;
}

export class BetsTable extends ArwabetBetsTable {
    render({data, onIdClick = null}) {
        return <Panel>
            <PanelRow>
                {!this.state.data.length?
                    <EmptyRecordsMessage />
                    : <Fragment>
                        <CustomTable style="font-family:'Arial rounded', Arial, sans-serif;" class="w-full table-auto border border-l-0 border-b-0 main-text-color">
                            <thead class="text-center font-bold bg-gray-200 body-bg-color">
                            <HRow>
                                <HCell><Trans>ID e Data</Trans></HCell>
                                <HCell><Trans>Username</Trans></HCell>
                                <HCell><Trans>Tipo Scommessa</Trans></HCell>
                                <HCell><Trans>Cashout</Trans></HCell>
                                <HCell><Trans>Puntata</Trans></HCell>
                                <HCell><Trans>N. Eventi</Trans></HCell>
                                <HCell><Trans>Quota Totale</Trans></HCell>
                                <HCell><Trans>Stato</Trans></HCell>
                                <HCell><Trans>Vincita</Trans></HCell>
                                <HCell />
                            </HRow>
                            </thead>
                            <tbody class="text-center">
                            {this.state.data.map(bet => <BetsTableRow row={bet} onIdClick={onIdClick} />)}
                            </tbody>
                        </CustomTable>
                        {!!this.state.onNavigation && <Pagination
                            pages={this.state.totalpages}
                            currentPage={this.state.page}
                            onNavigation={page => {this.state.onNavigation(page, page*this.state.recordperpage-this.state.recordperpage)}}
                            isLastPage={this.state.totalpages===this.state.page}
                        />}
                    </Fragment>}
            </PanelRow>
        </Panel>;
    }
}

export class BetsTableRow extends ArwabetBetsTableRow {
    renderCashoutButton(ticket) {
        return !this.state.cashoutvalue?
            <a href="javascript:void(0)" class="betstable-cashout-button button-minimal text-xs font-bold rounded leading-5" onClick={e => this.askCashoutInfo(ticket)}>
                <Trans>Cashout <i class="fa fa-stopwatch inline-block ml-1" /></Trans>
            </a>
            : <div>
                <a href="javascript:void(0);" class="p-2 inline-block" onClick={e => this.setState({cashoutvalue: false})}>
                    <i class="fa fa-times text-red-500" />
                </a>
                <span class="button py-1 px-2 main-text-color"><MoneyFormatter value={this.state.cashoutvalue} curency={ticket.currency} /></span>
                <a href="javascript:void(0);" class="p-2 inline-block" onClick={e => this.confirmCashoutInfo(ticket)}>
                    <i class="fa fa-check text-green-500" />
                </a>
            </div>;
    }

    printDateFormat(datestring) {
        const d = new Date(datestring);
        return <span>
            {d.toLocaleDateString(undefined, {day:'2-digit', month:'2-digit', year:'numeric'})}
            &nbsp;
            {d.toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit', hourCycle: 'h23'})}
        </span>;
    }

    statusIcon(row) {
        let iconColor = '';
        let iconType = '';

        switch (row.statusCode) {
            case 'N': iconType = 'fa-clock'; break;
            case 'R': iconType = 'fa-fa-hourglass'; break;
            case 'M':
            case 'V': iconType = 'fa-check-circle'; iconColor = 'text-green-500'; break;
            case 'P': iconType = 'fa-circle-xmark'; iconColor = 'text-red-500'; break;
            case 'C':
            case 'A':
            case 'D': iconType = 'fa-times'; iconColor = 'text-red-500'; break;
            case 'S':
                if (!!row.vincita) {
                    iconType = 'fa-check-circle';
                    iconColor = 'text-green-500';
                } else {
                    iconType = 'fa-circle-xmark';
                    iconColor = 'text-red-500';
                }
                break;
        }

        return <span class={"text-right "+ iconColor}><i class={"fa "+ iconType} /></span>;
    }

    renderPrematchDetails(details) {
        return Object.values(details).map(
            item => <Row class="betstable-details-row">
                <Cell class="w-1/10 p-2 border-r betstable-border-color">{this.printDateFormat(item.data_evento)}</Cell>
                <Cell class="w-4/10 p-2 text-left border-r betstable-border-color">
                    <div class="flex items-center justify-center">
                        <span class="w-full">{item.evento}</span>
                        {!!item.risultato && <span class="shrink-0 grow-0 flex flex-col items-center justify-center text-center gap-1">
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>FT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.risultato['@CASA'] != 'undefined' && item.risultato['@CASA'] !== null? item.risultato['@CASA'] + '-' : ''}
                                    {typeof item.risultato['@FUORI'] != 'undefined' && item.risultato['@FUORI'] !== null? item.risultato['@FUORI']: ''}
                                </span>
                            </span>
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>HT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.risultato['@CASAPT'] != 'undefined' && item.risultato['@CASAPT'] !== null? item.risultato['@CASAPT'] + '-' : ''}
                                    {typeof item.risultato['@FUORIPT'] != 'undefined' && item.risultato['@FUORIPT'] !== null? item.risultato['@FUORIPT']: ''}
                                </span>
                            </span>
                        </span>}
                    </div>
                </Cell>
                <Cell class="w-3/10 p-2 text-left border-r betstable-border-color">{item.scommessa} - {item.esito}</Cell>
                <Cell class="w-1/10 p-2 font-bold border-r betstable-border-color main-color"><OddsFormatter odds={item.quota} /></Cell>
                <Cell class="w-1/10 p-2">
                    {!!item.status && <div class="flex flex-row">
                        <span class="w-full">{this.outcomeStatusDescription(item.status)}</span>
                        <span class={'w-full text-right ' + (item.status==='P'? 'text-red-600' : 'text-green-600')}>
                            <i class={"fa "+ (item.status==='P'? 'fa-circle-xmark' : 'fa-check-circle')} />
                        </span>
                    </div>}
                </Cell>
            </Row>
        );
    }

    renderLiveDetails(details) {
        return details.map(
            item => <Row class="betstable-details-row">
                <Cell class="w-1/10 p-2 border-r betstable-border-color">{!!item.event.date? this.printDateFormat(item.event.date) : ''}</Cell>
                <Cell class="w-4/10 p-2 text-left border-r betstable-border-color">
                    <div class="flex items-center justify-center">
                        <span class="w-full">{item.event.name}</span>
                        {!!item.event.results && <span class="shrink-0 grow-0 flex flex-col items-center justify-center text-center gap-1">
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>FT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.event.results['@CASA'] != 'undefined' && item.event.results['@CASA'] !== null? item.event.results['@CASA'] + '-' : ''}
                                    {typeof item.event.results['@FUORI'] != 'undefined' && item.event.results['@FUORI'] !== null? item.event.results['@FUORI']: ''}
                                </span>
                            </span>
                            <span class="flex items-center justify-center gap-1">
                                <span class="text-left w-full text-xxs font-bold"><Trans>HT</Trans></span>
                                <span class="text-right w-full">
                                    {typeof item.event.results['@CASAPT'] != 'undefined' && item.event.results['@CASAPT'] !== null? item.event.results['@CASAPT'] + '-' : ''}
                                    {typeof item.event.results['@FUORIPT'] != 'undefined' && item.event.results['@FUORIPT'] !== null? item.event.results['@FUORIPT']: ''}
                                </span>
                            </span>
                        </span>}
                    </div>
                </Cell>
                <Cell class="w-3/10 p-2 text-left border-r betstable-border-color">{item.outcome.market} - {item.outcome.name}</Cell>
                <Cell class="w-1/10 p-2 font-bold border-r betstable-border-color main-color"><OddsFormatter odds={item.outcome.odd} /></Cell>
                <Cell class="w-1/10 p-2">
                    {!!item.outcome.status && <div class="flex flex-row">
                        <span class="w-full">{this.outcomeStatusDescription(item.outcome.status)}</span>
                        <span class={'w-full text-right ' + (item.outcome.status==='L'? 'text-red-500' : 'text-green-500')}>
                            <i class={"fa "+ (item.outcome.status==='L'? 'fa-circle-xmark' : 'fa-check-circle')} />
                        </span>
                    </div>}
                </Cell>
            </Row>
        );
    }

    render({row, onIdClick = null}) {
        return <Fragment>
            <Row class="betstable-main-row align-middle">
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="betstable-print-button"
                        onClick={e => !!onIdClick && onIdClick({id:row.code, code:row.code.toUpperCase()})}
                    >
                        {row.code.toUpperCase()}
                        <i class="fa fa-print main-color ml-3" />
                    </a>
                    <span class="block text-xs leading-3 pb-1">
                        {this.printDateFormat(row.time)}
                    </span>
                </Cell>
                <Cell>{row.username}</Cell>
                <Cell>{row.type}</Cell>
                <Cell>
                    {!!row.cashout && this.renderCashoutButton(row)}
                </Cell>
                <Cell><MoneyFormatter value={row.importo_scommesso} currency={row.currency} /></Cell>
                <Cell>
                    {row.eventi}
                    {!!row.presi? <span> / <span class="text-green-600 font-bold">{row.presi}</span></span> : ''}
                </Cell>
                <Cell class="main-color font-bold"><OddsFormatter odds={row.tot_odd} /></Cell>
                <Cell>
                    <span class="flex flex-row items-center justify-center">
                        <span class="w-full text-xs font-bold text-left">{row.status}</span>
                        {this.statusIcon(row)}
                    </span>
                </Cell>
                <Cell><MoneyFormatter value={row.vincita} currency={row.currency} /></Cell>
                <Cell>
                    <a
                        href="javascript:void(0);"
                        class="block px-2"
                        onClick={e => this.setState({showdetails: !this.state.showdetails})}
                    >
                        <i class={"fa "+ (!this.state.showdetails? 'fa-chevron-down' : 'fa-chevron-up')} />
                    </a>
                </Cell>
            </Row>
            {!!this.state.showdetails && <Row>
                <Cell colspan="10">
                    <CustomTable class="w-full border-b-4 text-xs font-sans border-(--main-color)">
                        <tbody>
                        {!!row.live? this.renderLiveDetails(row.dettaglio) : this.renderPrematchDetails(row.dettaglio)}
                        </tbody>
                    </CustomTable>
                </Cell>
            </Row>}
            <Row>
                <Cell colspan="10" class="border-0 p-0">
                    <div class="block w-full py-px" />
                </Cell>
            </Row>
        </Fragment>;
    }
}
